import createEnum from 'scripts/lib/create_enum';

const TypingState = createEnum('STARTED', 'PAUSED', 'STOPPED');

export default TypingState;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/typing_state.js